import t from './Auth.type';
import { localStorageService } from '../../../services/localStorage.service';
import * as services from '../../../services/auth.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { backendErrorMsg, getApiErrorKey } from '../../../Components/helper';
import { HTTP_STATUS } from '../../../constants/api-status-codes';

export const loadUser = () => async (dispatch) => {
  const userInfo = await localStorageService.get('loggedInUserInfo');
  if (userInfo) {
    await dispatch({ type: t.SET_CURRENT_USER, payload: userInfo });
    return userInfo;
  }
  return null;
};

export const forgetPassword = (data, trans) => {
  return async () => {
    try {
      const response = await services.forgotPassword(data);

      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`, { email: response?.data?.Email }), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
    }
    return null;
  };
};

export const SetupSecurityQuestions = (data, trans) => {
  return async () => {
    try {
      const response = await services.setSecurityQuestions(data);

      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`, { email: response?.data?.Email }), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
    return null;
  };
};

export const SignupUser = (data, trans) => {
  return async () => {
    try {
      const response = await services.signup(data);

      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
    return null;
  };
};

export const fetchSecurityQuestions = (data, trans) => {
  return async (dispatch) => {
    try {
      const response = await services.fetchSecurityQuestion(data);
      if (response && response?.code === 200) {
        await dispatch({
          type: t.FETCH_SECURITY_QUESTIONS,
          payload: response.data,
        });
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const verifySecurityQuestions = (data, trans) => {
  return async () => {
    try {
      const response = await services.verifySecurityQuestion(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
    return null;
  };
};

export const Login = (data, trans) => {
  return async () => {
    try {
      const response = await services.login(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`), 'success');
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
    return null;
  };
};

export const verifyOtp = (data, trans) => {
  return async (dispatch) => {
    try {
      const response = await services.verifyOtp(data);
      if (response && response?.code === 200) {
        await dispatch({
          type: t.VERIFY_OTP,
          payload: response.data,
        });
        toasterMsg(trans(`AUTHENTICATION.${response?.message}`), 'success');
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
        return response.data;
      }
      return response.data;
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const getMFAQrCode = (data) => {
  return async () => {
    try {
      const response = await services.getMfaQrCodeData(data);
      if (response && response?.code === 200) {
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(response?.data?.errMsg, 'danger');
      }
      return response.data;
    } catch (error) {
      showRequestError(error);
      throw error;
    }
  };
};

export const enableMfa = (data, trans) => {
  return async () => {
    try {
      const response = await services.enableMfaSetup(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response?.message}`), 'success');
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
      return response.data;
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const verifyCode = (data, trans) => {
  return async () => {
    try {
      const response = await services.verifiedCode(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response?.message}`), 'success');
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
        return response.data;
      }
      return response.data;
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const recoverUsersMFA = (data, trans) => {
  return async () => {
    try {
      const response = await services.recoverMFAaccount(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response?.message}`), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const recoverRequestSent = (data, trans) => {
  return async () => {
    try {
      const response = await services.recoveryRequest(data);
      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response?.message}`), 'success');
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
        return response.data;
      }
      return response.data;
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
  };
};

export const changeSecurityQuestions = (data, trans) => {
  return async () => {
    try {
      const response = await services.changeSecurityQuestions(data);

      if (response && response?.code === 200) {
        toasterMsg(trans(`AUTHENTICATION.${response.message}`), 'success');
        return true;
      }
      if (response?.data?.errMsg) {
        toasterMsg(trans(response?.data?.errMsg), 'danger');
      }
    } catch (error) {
      showRequestError(error, trans);
      throw error;
    }
    return null;
  };
};

export const getIsVerified = (data) => {
  return async () => {
    try {
      const response = await services.getIsVerified(data);
      if (response && response?.code === 200) {
        return response.data;
      }
      if (response?.data?.errMsg) {
        toasterMsg(response?.data?.errMsg, 'danger');
      }
      return response;
    } catch (error) {
      toasterMsg('Something went wrong', 'danger');
      throw error;
    }
  };
};

export const getVerify = (data) => {
  return async () => {
    try {
      const response = await services.getUserverify(data);
      if (response && response?.code === 200) {
        return response;
      }
      if (response?.data?.errMsg) {
        toasterMsg('Something went wrong', 'danger');
      }
      return response.data;
    } catch (error) {
      toasterMsg('Something went wrong', 'danger');
      throw error;
    }
  };
};

function showRequestError(error, trans) {
  if (error?.response?.status === HTTP_STATUS.TOO_MANY_REQUESTS) {
    return;
  }
  toasterMsg(backendErrorMsg(trans, getApiErrorKey(error)), 'danger');
}
